<template>
  <div class="storage-register">
    <div class="storage-register-search">
      <div class="screen">
        <el-select class="white w200" clearable v-model="screen.projectId" placeholder="请选择项目" filterable>
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="w200"
          v-model="screen.date"
          type="month"
          placeholder="请选择月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
        >
        </el-date-picker>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
      
      <div class="search-right-content">
        <el-button class="btn-white paddingRight" @click="exportExit">导出</el-button>
        <el-upload
          element-loading-text="文件导入中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload tbc-upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" class="btn-white">导入</el-button>
        </el-upload>
      </div>
    </div>

    <div class="tips" v-if="closeTips">
      <div class="title">
        <div class="title-left">
          <i class="el-icon-warning"></i>
          <span>日期筛选规则：</span>
        </div>
        <i class="el-icon-close" @click="closeTips = false"></i>
      </div>
      <p>1、筛选日期后，表示该进仓单入库日期~当前选择日期内的自然月；</p>
      <p>2、已登记过的自然月不会重复登记结算；</p>
    </div>

    <el-form
      ref="storageRegisterForm"
      :model="storageRegisterForm"
    >
      <el-form-item label="币制：" prop="currencySystem">
        <el-select class="white"
          v-model="storageRegisterForm.currencySystem" placeholder="请选择币制">
          <el-option v-for="item in currencySystemList" :key="item.id" :label="item.name"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代收代付：" prop="agentBusiness">
        <el-radio-group v-model="storageRegisterForm.agentBusiness">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="默认应收抬头：" prop="defaultAccountsReceivableHeader" :rules="[
          { required: true, message: '请选择默认应收抬头', trigger: 'change' },
        ]"
      >
        <el-select class="white" filterable
          v-model="storageRegisterForm.defaultAccountsReceivableHeader" placeholder="请选择默认应收抬头">
          <el-option v-for="item in defaultAccountsReceivableHeaderList.filter(data => data.status)"
            :key="item.id" :label="item.customizeName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="code">
      <el-checkbox-group  v-if="codeList.length" v-model="checkedCode" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="item in codeList" :label="item" :key="item">
          <span>进仓单号：</span>
          {{item}}
        </el-checkbox>
      </el-checkbox-group>
      
      <div class="nothing" v-else>
        <div class="img">
          <img src="~assets/images/nothing2.png" />
        </div>
        <div class="nothing-tips">查询数据为空</div>
      </div>
      <div class="footer">
        <el-checkbox :disabled="!codeList.length" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div class="register-btn">
          <span class="register-nums" v-if="codeList.length">已选{{checkedCode.length}}个进仓单</span>
          <el-button :disabled="!codeList.length" class="btn-blue" @click="saveRegister('storageRegisterForm')">开始登记</el-button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import LookUpMixins from "common/mixins/look-up.js";
import currencyMixins from "common/mixins/currency.js";
import StorageRegister from "models/storage-register";
import EnterExitWarehouseProjectMixins from 'common/mixins/enter-exit-warehouse-project'
import { modifyNetTitle } from "common/js/util";
export default {
  mixins: [EnterExitWarehouseProjectMixins, LookUpMixins, currencyMixins],

  data() {
    return {
      screen: {
        projectId: "",
        date: ""
      },
      closeTips: true,
      storageRegisterForm: {
        currencySystem: 'CNY',
        agentBusiness: 0,
        defaultAccountsReceivableHeader: null
      },
      checkedCode: [],
      codeList: [],
      checkAll: false,
      isIndeterminate: false,
      
      loading2: false,
    }
  },

  created() {
    modifyNetTitle('存储登记')
    this.defaultMonth()
    this.initEnterExitWarehouseProjectData();
    this.initDefaultAccountsReceivableHeaderList()
  },

  methods: {
    defaultMonth() {
      //默认显示上月日期
      let date = new Date(new Date() - 30 * 24 * 3600 * 1000);
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let newMonth = month < 10 ? `0${month}`: month
      this.screen.date = `${year}-${newMonth}`
    },

    etLastDayOfMonth(year, month) {
      // 月份是从0开始的，所以1月是0，12月是11
      // 直接构造下个月的第一天的前一天即为当前月的最后一天
      return new Date(year, month, 0).getDate();
    },
    
    onScreen() {
      let date = new Date(this.screen.date)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let projectId = this.screen.projectId
      let calculateDeadlineDay = `${this.screen.date}-${this.etLastDayOfMonth(year, month)}`
      if (!projectId) return this.$message.error('请选择项目')
      let data = {
        projectId,
        calculateDeadlineDay
      }
      StorageRegister.getStorageRegisterEntryExitCodeList(data).then(res => {
        if (res.success) {
          let codeList = [];
          res.result.map(value => {
            codeList.push(value);
          });
          this.codeList = codeList;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleCheckAllChange(val) {
      this.checkedCode = val ? this.codeList : [];
      this.isIndeterminate = false;
    }, 
    
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.codeList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.codeList.length;
    },

    saveRegister(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$confirm("是否确定以选中进仓单开始登记？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            confirmButtonClass: 'btn-blue',
            cancelButtonClass: 'btn-white',
            customClass: "messageBox420",
            type: "warning"
          }).then(() => {
            let date = new Date(this.screen.date)
            let year = date.getFullYear()
            let month = date.getMonth() + 1

            let projectId = this.screen.projectId
            let calculateDeadlineDay = `${this.screen.date}-${this.etLastDayOfMonth(year, month)}`
            let billHeadId = this.storageRegisterForm.defaultAccountsReceivableHeader
            let currency = this.storageRegisterForm.currencySystem
            let agentBusiness = this.storageRegisterForm.agentBusiness?true:false
            let data = {
              projectId,
              calculateDeadlineDay,
              inboundOrderNoList: this.checkedCode,
              currency,
              agentBusiness,
              billHeadId
            }
            StorageRegister.postSaveStorageRegister(data).then(res => {
              if (res.success) {
                this.$message.success('登记成功');
              } else {
                this.$message.error(res.message);
              }
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
    /* 导出 */
    exportExit() {
      let projectId = this.screen.projectId
      let date = this.screen.date
      if (!projectId) {
        return this.$message.error('请选择项目')
      }
      if (!date) {
        return this.$message.error('请选择日期')
      }
      StorageRegister.getExportExcel(projectId, date).then((res) => {
        res.data.text().then(text => {
          try {
            const json = JSON.parse(text);
            // 处理错误信息
            this.$message.error(json.message)
          } catch {
            let blob = new Blob([res.data], { type: res.headers.contentType });
            let fileName = window.decodeURI(
              res.headers["content-disposition"].split("=")[1]
            );
            var url = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            // 释放之前创建的URL对象
            window.URL.revokeObjectURL(url);
          }
        });
      })
    },

    // 导入
    uploadExcel(file) {
      let projectId = this.screen.projectId
      let date = this.screen.date
      if (!projectId) {
        return this.$message.error('请选择项目')
      }
      if (!date) {
        return this.$message.error('请选择日期')
      }
      var formData = new FormData();
      formData.append("file", file);
      formData.append("projectId", projectId);
      formData.append("balanceMonth", date);
      this.loading2 = true;
      StorageRegister
        .postUploadStorageRegisterExcel(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loading2 = false;
            this.initTBCRecord()
          } else {
            this.loading2 = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(() => {
          this.$message.error("导入失败");
          this.loading2 = false;
        });
      return false;
    },
  }
}
</script>

<style lang='scss'>
.storage-register {
  flex: 1;
  overflow: auto;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 0px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .storage-register-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .screen {
      display: flex;
      .w200 {
        width: 200px;
        margin-right: 20px;
      }
    }
    .search-right-content {
      display: flex;
      .paddingRight {
        margin-right: 16px;
      }
    }
    .operation-btn {
      display: flex;
    }
  }
  .tips {
    height: 106px;
    border-radius: 4px;
    padding: 16px 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
    background: rgba(46,104,234,0.05);
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-left {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-bottom: 4px;
        font-family: 'PingFang SC-Regular';
        .el-icon-warning {
          width: 16px;
          height: 16px;
          color: #2E68EA;
          margin-right: 8px;
        }
        .el-icon-close {
          width: 10px;
          height: 10px;
          color: #BFBFBF;
        }
      }
    }
    p {
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 28px;
      padding-left: 24px;
    }
  }
  .el-form {
    display: flex;
    justify-content: space-between;
    .el-form-item {
      display: flex;
      margin-bottom: 20px;
      .el-form-item__label {
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
    }
    .el-select {
      width: 240px;
    }
    .el-radio-group {
      .el-radio__input.is-disabled .el-radio__inner {
        background-color: white;
        border-color: #DDE1E7;
      }

      .el-radio__input.is-disabled.is-checked:hover {
        border-color: #DDE1E7;
      }

      .el-radio__input.is-disabled.is-checked .el-radio__inner,
      .el-radio__inner:hover,
      .el-radio__input.is-checked .el-radio__inner {
        background-color: white;
        border-color: #2E68EA;
      }

      .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
      .el-radio__inner::after {
        background-color: #2E68EA;
      }

      .el-radio__input.is-checked+.el-radio__label {
        color: #2E68EA;
      }
      .el-radio__label {
        display: inline-block;
        margin-top: 1px;
      }
    }
  }
  .code {
    flex: 1;
    padding: 20px 20px 40px 20px;
    margin-bottom: 50px;
    border: 1px solid #EBEEF5;
    display: flex;
    flex-direction: column;
    .nothing {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .img {
        width: 160px;
        height: 113px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .nothing-tips {
        font-family: 'PingFang SC-Regular';
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
    }
    .el-checkbox-group {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      column-gap: 20px;
      row-gap: 20px;
      .el-checkbox {
        height: 48px;
        margin-right: 0px;
        border-radius: 4px;
        background: #F5F7FA;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0px 10px;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        font-family: 'PingFang SC-Regular';
      }
    }
    
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2E68EA;
      border-color: #2E68EA;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner,
    .el-checkbox__inner:hover {
      border-color: #2E68EA;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner::after {
      border-color: #fff;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      background-color: #EBEEF5;
      border-color: #EBEEF5;
    }
    .el-checkbox .el-checkbox__label,
    .el-checkbox__input.is-disabled+span.el-checkbox__label,
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #333333;
      font-family: 'PingFang SC-Regular';
    }
    .footer {
      position: fixed;
      width: calc(100% - 232px);
      bottom: 46px;
      left: 216px;
      padding-left: 30px;
      padding-right: 19px;
      box-sizing: border-box;
      height: 66px;
      z-index: 9;
      overflow: hidden;
      background: white;
      box-shadow: 0px -3px 6px 1px rgba(51,51,51,0.05);
      display: flex;
      align-items: center;
      justify-content: space-between;
      .register-btn {
        .register-nums {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          font-family: 'PingFang SC-Regular';
          margin-right: 10px;
        }
      }
      .el-button.is-disabled {
        background: #96B3F4;
        border-color: #96B3F4;
      }
    }
  }
  
}
</style>
